export const EDITABLE_ORDER_STATUSES = ['pending', 'ready_for_pickup', 'processing'];
export const EDITABLE_PAYMENT_METHODS = ['cash_on_delivery', 'in_person'];

// Mirrors OrderEditService.assertOrderEditable on the backend. `order.source`
// being undefined (pre-migration orders) is treated as editable-by-default —
// the backend does its own authoritative fallback check and will reject with
// a translated error in the rare case it's actually not editable.
export function isOrderEditable(order) {
  if (!order) return false;
  if (!EDITABLE_ORDER_STATUSES.includes(order.status)) return false;
  if (!EDITABLE_PAYMENT_METHODS.includes(order.payment?.method)) return false;
  if (order.orderNumber?.startsWith('SUB-')) return false;
  if (order.source === 'legacy') return false;
  return true;
}
